import { writable } from 'svelte/store';
const TOAST_DEFAULT_TIMEOUT = 5_000;
// Store that holds the list of current Toast elements
export const toasts = writable([]);
export function showToast(text, options = {}) {
    // Generate a unique ID
    const id = crypto.randomUUID();
    const toast = {
        id,
        text,
        ...options,
    };
    // Add the new Toast to the end of the list
    toasts.update((all) => [...all, toast]);
    // Dismiss the Toast automatically after the passed duration or the default timeout
    setTimeout(() => {
        dismissToast(id);
    }, options.duration ?? TOAST_DEFAULT_TIMEOUT);
}
/**
 * Remove a Toast from the list by its unqiue ID
 *
 * @param id - The unique ID of the Toast
 */
export function dismissToast(id) {
    toasts.update((allToasts) => allToasts.filter((toast) => toast.id !== id));
}
